import { render } from "./ProgramAssigneeItem.vue?vue&type=template&id=3e8e795c&scoped=true"
import script from "./ProgramAssigneeItem.vue?vue&type=script&lang=js"
export * from "./ProgramAssigneeItem.vue?vue&type=script&lang=js"

import "./ProgramAssigneeItem.vue?vue&type=style&index=0&id=3e8e795c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8e795c"]])

export default __exports__